export const PLAYBACK_CONTAINER_WIDGET = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.PlaybackContainerWidgetElement';
